var sizeguideComponent = class extends HTMLElement {
    popup = this.querySelector('.size-guide__popup-container');
    overlay = this.querySelector('.size-guide__overlay');
    button = document.querySelector('.size-guide__open');
    close = this.querySelector('.size-guide__close');
    tab = this.querySelectorAll('.size-guide__tab');

    connectedCallback() {
        this.button.addEventListener('click', () => this.openPopup());
        this.close.addEventListener('click', () => this.openPopup());
        this.overlay.addEventListener('click', () => this.openPopup());
        this.tab.forEach(tab => tab.addEventListener('click', () => this.openTab(tab)));
    }
    openPopup() {
        this.popup.classList.toggle('open');
        this.overlay.classList.toggle('open');
    }
    openTab(tab) {
        this.tab.forEach(tab => tab.classList.remove('active'));
        tab.classList.add('active');
        const tabId = tab.getAttribute('data-tab');

        // hide all 
        this.querySelectorAll('[data-tab-content]').forEach(tabContent => tabContent.classList.remove('visually-hidden')); 
        this.querySelectorAll('[data-tab-content]').forEach(tabContent => tabContent.classList.add('visually-hidden'));
        
        // display interested
        this.querySelectorAll('[data-tab-content="'+ tabId +'"]').forEach(tabContent => tabContent.classList.remove('visually-hidden'));
    }
};

window.customElements.define("size-guide", sizeguideComponent);
